module.exports = __webpack_public_path__ + "img/danxiangpaiqifa-nei.0f61f3d3.jpg";